<template id="personal_center">
  <div>
    <toast></toast>
    <div class="col-md-12 pr-0 pl-0 centre_sm_none">
      <div class="accountManage">
        <p class="account_manage_title">Account settings</p>
        <ul class="nav nav-tabs" role="tablist">
          <li role="presentation" class="account_manage_title_active">
            <a href="javascript:" @click="msga=0" :class="{'account_manage_title_active':msga===0}">Basic settings</a>
          </li>
          <li role="presentation">
            <a href="javascript:" @click="msga=1" :class="{'account_manage_title_active':msga===1}">Account settings</a>
          </li>
        </ul>

        <div class="tab-content">
          <div v-show="msga==0" class="nano video_breviary" id="accountSettings">
            <div class="nano-content">
              <form>
                <div class="form-group row ml-0 mr-0">
              <!-- <label class="col-md-2 col-4 col-form-label tc">修改头像</label> -->
				  <label class="nano-lable">Change your portrait</label>
                  <div class="ano-content-art">
                    <img :src="user.thumb ? user.thumb : '../../../assets/images/silkRoadBase/nohead.png'" />

                      <span class="btn  fileinput-button" style="margin-left: 20px;color:#fff;background-color: #208EFF;border-color: #208EFF">
                            <span>Upload a portrait</span>
                            <input type="file" @change="upload()"/>
                      </span>
                  </div>
                </div>

                <div class="form-group row ml-0 mr-0" >
                  <label class="nano-lable">User name</label>
                  <div class="col-4">
                    <input
                      type="text"
                      v-model="user.nickname"
                      readonly
                      class="form-control"
                    >
                  </div>
                </div>
                <div class="form-group row ml-0 mr-0">
                  <label class="nano-lable">Gender</label>
                  <div class="col-8">
                    <label class="demo--label" style="padding-left: 0;">
                      <input class="demo--radio" v-model="user.gender" value="男" type="radio" name="sex">
                      <span class="demo--radioInput"></span>Male
                    </label>
                    <label class="demo--label" style="padding-left: 0;">
                      <input class="demo--radio" v-model="user.gender" value="女" type="radio" name="sex">
                      <span class="demo--radioInput"></span>Female
                    </label>
                  </div>
                </div>
                <div class="form-group row ml-0 mr-0">
                  <label class="nano-lable">Name</label>
                  <div class="col-4">
                    <input type="text" v-model="user.truename" class="form-control" style="">
                  </div>
                </div>
                <div class="form-group row ml-0 mr-0">
                  <label class="nano-lable">Date of Birth</label>
                  <div class="col-8">
                    <select
                      id="year"
                      v-model="user.year"
                      class="form-control w-15"
                      style="display: initial; height: calc(1.9rem + 2px);"
                    >
                      <option v-bind:value="year" v-for="year in msgs">{{year}}</option>
                    </select>&emsp;YY&emsp;
                    <select
                      id="month"
                      v-model="user.month"
                      class="form-control w-15"
                      style="display: initial; height: calc(1.9rem + 2px);"
                    >
                      <option v-bind:value="month" v-for="month in 12">{{month}}</option>
                    </select>&emsp;MM&emsp;
                    <select
                      id="day"
                      v-model="user.day"
                      class="form-control w-15"
                      style="display: initial; height: calc(1.9rem + 2px);"
                    >
                      <option v-bind:value="day" v-for="day in 31">{{day}}</option>
                    </select>&emsp;DD&emsp;
                  </div>
                </div>
                <!-- <div class="form-group row ml-0 mr-0">
                  <label class="nano-lable">QQ</label>
                  <div class="col-8">
                    <input type="text" v-model="qq" class="col-md-4 col-12 form-control">
                  </div>
                </div> -->

                <!-- <div class="form-group row ml-0 mr-0">
                  <label class="nano-lable">手机</label>
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="phone"
                      readonly
                      class="col-md-4 col-12 form-control"
                    >
                  </div>
                </div> -->
                <!-- <div class="form-group row ml-0 mr-0">
                  <label class="nano-lable">职业</label>
                  <div class="col-8">
                    <input type="text" v-model="job" class="col-md-4 col-12 form-control">
                  </div>
                </div> -->
				 <div class="form-group row ml-0 mr-0">
                  <label class="nano-lable">Present employer</label>
                  <div class="col-8">
                    <input type="text" v-model="user.unit" class="form-control" style="">
                  </div>
                </div>
                <div class="form-group row ml-0 mr-0">
                  <label class="nano-lable">Address</label>
                  <div class="col-8">
                    <input type="text" v-model="user.address" class="form-control">
                  </div>
                </div>

                <!-- <div class="form-group row ml-0 mr-0">
                  <label class="nano-lable">邮编</label>
                  <div class="col-8">
                    <input type="text" v-model="postcode" class="col-md-4 col-12 form-control">
                  </div>
                </div> -->
                <div class="w-100" style="margin-left:200px;margin-bottom: 18px;">
                  <span @click="memberedit" class="btn btn-primary" style="width: 110px;height:34px;font-size:14px">Save</span>
                </div>
              </form>
            </div>
          </div>
          <div v-show="msga==1" class="nano video_breviary" id="profile">
            <div class="nano-content">
              <div class="card border-top-0 border-right-0 border-left-0" style="margin: 0 1.8rem!important;">
                <div class="card-body card-main">
                  <div class="float-left" style="line-height: 108px;">
                      <img v-if="!user.mobile" src="../../../assets/images/silkRoadBase/biconzhuanhuan-.png" />
                      <img v-if="user.mobile" src="../../../assets/images/silkRoadBase/Group-.png" />
                  </div>
                  <div class="float-left f15 ml-2 mt15">
                    <p class="p-0 ml-2">
                      <span class="d-block mt-2 mb-2" >Mobile number verification</span>
                      <span class="text-black-50 f12" >Validate mobile number：{{user.mobile}}</span>
                    </p>
                  </div>
                  <div class="float-right" style="line-height: 108px;">

                    <a href="javascript:" class="text-secondary f15" v-if="user.mobile" @click="pop(1)">Edit</a>
                    <a href="javascript:" class="text-secondary f15" v-if="!user.mobile" @click="pop(1)">Add</a>
                  </div>
                </div>
              </div>
              <div class="card border-top-0 border-right-0 border-left-0" style="margin: 0 1.8rem!important;">
                <div class="card-body  card-main">
                  <div class="float-left" style="line-height: 108px;">
                    <img v-if="!user.email" src="../../../assets/images/silkRoadBase/biconzhuanhuan-.png" />
                    <img v-if="user.email" src="../../../assets/images/silkRoadBase/Group-.png" />
                  </div>
                  <div class="float-left f15 ml-2 mt15">
                    <p class="ml-2 p-0">
                      <span class="d-block mt-2 mb-2" >Mailbox verification</span>
                      <span class="text-black-50 f12" >Validate e-mail address：{{user.email}}</span>
                    </p>
                  </div>
                  <div class="float-right" style="line-height: 108px;">
                    <a href="javascript:" class="text-secondary f15" v-if="user.email" @click="pop(2)">Edit</a>
                    <a href="javascript:" class="text-secondary f15" v-if="!user.email" @click="pop(2)">Add</a>
                  </div>
                </div>
              </div>
              <div class="card border-top-0 border-right-0 border-left-0" style="margin: 0 1.8rem!important;">
                <div class="card-body  card-main">
                  <div class="float-left" style="line-height: 108px;">
                    <img src="../../../assets/images/silkRoadBase/Group-.png"/>
                  </div>
                  <div class="float-left f15 ml-2 mt15">
                    <p class="ml-2 p-0">
                      <span class="d-block mt-2 mb-2" >Login password re-setting</span>
                      <span class="text-black-50 f12">It is recommended that you re-set your password regularly to enhance account security。</span>
                    </p>
                  </div>
                  <div class="float-right" style="line-height: 108px;">
                    <a href="javascript:" class="text-secondary f15" @click="pop(3)">Edit</a>
                  </div>
                </div>
              </div>
              <div class="card border-0" style="margin: 0 1.8rem!important;">
                <div class="card-body  card-main">
                  <div class="float-left" style="line-height: 90px;">
                    <img v-if="!user.wx_nickname" src="../../../assets/images/silkRoadBase/biconzhuanhuan-.png" />
                    <img v-if="user.wx_nickname" src="../../../assets/images/silkRoadBase/Group-.png" />
                  </div>
                  <div class="float-left f15 mt-2 ml-2 mt15">
                    <p class="ml-2 p-0">
                      <span class="d-block mb-2 mt-2">Connect to your WeChat account</span>
                      <span v-if="!user.wx_nickname" class="text-black-50 f12">You can log into Xinhua Silk Road via your WeChat account directly 。</span>
                      <span v-if="user.wx_nickname" class="text-black-50 f12">Your WeChat account：{{user.wx_nickname}}</span>
                    </p>
                  </div>
                  <div class="float-right" style="line-height: 108px;">
                    <a href="/wechatbind" class="text-secondary f15" v-if="!user.wx_nickname">Binding</a>
                    <a href="/wechatbind" class="text-secondary f15" v-if="user.wx_nickname">Unbinding</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
      <div class="bg-model" v-show="maskShow">
          <div class="maskContent">
              <div class="maskHeeard">{{currentPop.title}}</div>
              <div class="maskForm">
                  <input :type="currentPop.type == 'password' ? 'password' : 'type'" v-model="currentPop.account"  :placeholder="currentPop.name" />
                  <input :type="currentPop.type == 'password' ? 'password' : 'type'" max-length="6" v-model="currentPop.captcha"  :placeholder="currentPop.pass" />
                    <div v-if="currentPop.name != 'New password'">
                      <div class="sendCode" v-if="!sendMsgDisabled" @click="send()">{{currentPop.code}}</div>
                      <div class="sendCode" v-if="sendMsgDisabled">{{time}}</div>
                    </div>
              </div>
              <div class="confirm" @click="store()">Confirm</div>
          </div>
      </div>
      <div class="result" v-show="resultShow">
          <div class="confirms">
              <img :src="results.url" alt="" height="25px" width="25px" />
              <span>{{results.name}}</span>
          </div>
      </div>
        <div class="result" v-show="errorShow">
        <div class="confirms" style="width:360px">
            <img src="../../../assets/images/silkRoadBase/failful.png" alt="" height="25px" width="25px" />
            <span>{{errorMessage}}</span>
        </div>
        </div>
  </div>
</template>
<script>
import toast from './toast/Toast'
export default {
  name: "accounts",
  data() {
    return {
        msga: this.$route.query.bind ? this.$route.query.bind : 0,
        msgs: [],
        user:{},
        accept: "image/gif, image/jpeg, image/png, image/jpg",
        maskShow:false,
        currentPop:{},
        time: 60, // 发送验证码倒计时
        sendMsgDisabled: false,
        interval:null,
        telPhone:"",
         pass:"",
        resultShow:false,
        errorShow:false,
        errorMessage:'',
        results:{},
        success:{
            url:'/images/successful.png',
            name:"Done"
        },
        fail:{
            url:'/images/failful.png',
            name:"Failure"
        },
         popList:[
             {
                 "name":"Mobile number",
                 'type':'mobile',
                 'pass':"Enter the code",
                 'title':"Change mobile number",
                 "code":'Verify my phone'
             }, {
                 "name":"E-mail",
                 'type': 'email',
                 'pass':"Enter the code",
                 'title':"Modify Mailbox Verification",
                 "code":'Verify my Email'
                 },
             {
                 "name":"New password",
                 'type': 'password',
                 'pass':"Confirm the new password",
                 'title':"Change password",
//                 "code":'发送邮箱验证码'
             }
         ]
    }
  },
  created: function() {

      let self = this;
      // 获取用户信息
      this.$axios.post('api/pc/getmember').then(data => {
          if (data.data.state) {
              self.user=data.data.data;

              if (self.user.wx_bind_error) {
                  self.errorMessage = self.user.wx_bind_error;
                  self.errorShow = true;
              }
              setTimeout(function () {
                  self.errorShow=false;
              },3000)
          }
      })
      self.msg();
  },
  mounted() {
      this.load();
      this.closeModel()
  },
  methods: {
      store(){
          var that=this;
          var param = {};
          param[that.currentPop.type] = that.currentPop.account;
          if (that.currentPop.name == 'New password') {
              // 验证密码是否为空
              if (!that.currentPop.account || !that.currentPop.captcha) {
                  $(".wrap").text('Password cannot be empty');
                  $(".wrap").show().delay(1500).hide(100);
                  return false;
              }

              // 验证两次密码是否一致
              if (that.currentPop.account != that.currentPop.captcha) {
                  $(".wrap").text('Two different formats');
                  $(".wrap").show().delay(1500).hide(100);
                  return false;
              }

              // 请求接口
              this.$axios.post("/api/pc/accountsecurity", param).then(data => {
                  if (data.data.state) {
                      that.results=that.success;
                  } else {
                      that.results=that.fail;
                  }
                  that.maskShow=false;
                  that.resultShow=true;
                  setTimeout(function () {
                      that.resultShow=false;
                  },2000)
              });

          } else {

              // 验证手机号或者邮箱是否正确
              var pattern = /(^1[34578]\d{9}$)|(^\w+@\w+(\.\w+){1,2}$)/;
              if (!that.currentPop.account || !pattern.test(that.currentPop.account)) {
                  $(".wrap").text(this.currentPop.name + ' Incorrect format');
                  $(".wrap").show().delay(1500).hide(100);
                  return false;
              }

              this.$axios.post("/api/pc/verifycode", {'account':that.currentPop.account, 'code':that.currentPop.captcha}).then(data => {
                  if (!data.data.state) {
                      $(".wrap").text(data.data.error);
                      $(".wrap").show().delay(1500).hide(100);
                      return false;
                  } else {

                      // 请求接口
                      this.$axios.post("/api/pc/accountsecurity", param).then(data => {
                          if (data.data.state) {
                              that.results=that.success;
                          } else {
                              that.results=that.fail;
                          }
                          that.maskShow=false;
                          that.resultShow=true;
                          setTimeout(function () {
                              that.resultShow=false;
                          },2000)
                      });


                  }
              });

          }

      },
      closeModel(){
          let that=this;
          $(document).mousedown(function(e){
              if(that.maskShow==true){
                  if($(e.target).hasClass("bg-model")){
                      that.maskShow=false;
                      that.time=60;
                      that.sendMsgDisabled = false;
                      if(that.interval){
                          window.clearInterval(that.interval);
                      }
                  }
              }
          })
      },
      send() {
            var pattern = /(^1[34578]\d{9}$)|(^\w+@\w+(\.\w+){1,2}$)/;
            if (!this.currentPop.account || !pattern.test(this.currentPop.account)) {
                $(".wrap").text(this.currentPop.name + ' Incorrect format');
                $(".wrap").show().delay(1500).hide(100);
                return false;
            }
          this.$axios.post("/api/pc/sendcode", {account:this.currentPop.account,type:'register'}, {headers:{'X-CSRF-TOKEN': document.querySelector('meta[name=csrf-token]').getAttribute('content')}}).then(data => {
              if (data.data.state) {
                  let me = this;
                  me.sendMsgDisabled = true;
                  if(this.interval==null){
                      this.interval = window.setInterval(function() {
                          if ((me.time--) <= 0) {
                              me.time = 60;
                              me.sendMsgDisabled = false;
                              window.clearInterval(me.interval);
                          }
                      }, 1000);
                  }else{
                      window.clearInterval(me.interval);
                      this.interval = window.setInterval(function() {
                          if ((me.time--) <= 0) {
                              me.time = 60;
                              me.sendMsgDisabled = false;
                              window.clearInterval(me.interval);
                          }
                      }, 1000);
                  }
              } else {
                  $(".wrap").text(data.data.error);
                  $(".wrap").show().delay(1500).hide(100);
                  return false;
              }

          });

      },
      pop(num){
          switch(num)
          {
              case 1:
                  this.currentPop=this.popList[0];
                  break;
              case 2:
                  this.currentPop=this.popList[1];
                  break;
              case 3:
                  this.currentPop=this.popList[2];
                  break;
              default:
                  this.currentPop=this.popList[0];
          }
          this.maskShow=true
      },
      memberedit: function() {
        var param = {
            thumb : this.user.thumb,
            gender : this.user.gender,
            truename : this.user.truename || '',
            year : this.user.year,
            month : this.user.month,
            day : this.user.day,
            unit: this.user.unit || '',
            address: this.user.address || ''
        };


        if (null) {
            console.log(1);
        } else {
            console.log(2);
        }
        console.log(param);
        this.$axios.post("/api/pc/editmember", param).then(data => {
            if (data.data.state) {
                $(".wrap").text('Save successfully');
                $(".wrap").show().delay(1500).hide(100);
            }
        });
    },
      upload : function () {
          let reader =new FileReader();
          let img1=event.target.files[0];
          let type=img1.type;//文件的类型，判断是否是图片
          let size=img1.size;//文件的大小，判断图片的大小
          if(this.accept.indexOf(type) == -1){
              $(".wrap").text('Please select the image format we support');
              $(".wrap").show().delay(1500).hide(100);
              return false;
          }
          if(size>3145728){
              $(".wrap").text('Please select pictures within 3M');
              $(".wrap").show().delay(1500).hide(100);
              return false;
          }
          let form = new FormData();
          form.append('file',img1,img1.name);
          this.$axios.post('/api/pc/uploadavatar',form,{
              headers:{'Content-Type':'multipart/form-data'}
          }).then(response => {
              if (response.data.state) {
                this.user.thumb = response.data.data.path;
              } else {
                  $(".wrap").text('Error uploading pictures');
                  $(".wrap").show().delay(1500).hide(100);
                  return false;
              }
          })
      },
      msg: function() {
          var date = new Date().getFullYear();
          for (var i = 0; i < 50; i++) {
              this.msgs.push(date);
              date -= 1;
          }
      }
  },
    components: {
        toast
    }
};
</script>
<style scoped>
    .fileinput-button {
        position: relative;
        display: inline-block;
        overflow: hidden;
        border-radius:4px;
    }

    .fileinput-button input{
        position:absolute;
        right: 0px;
        top: 0px;
        opacity: 0;
        -ms-filter: 'alpha(opacity=0)';
        font-size: 200px;
    }
    .bg-model{
        position:absolute;top:0%;left:0%;background:rgba(0,0,0,0.3);width:100%;height:100%;position:fixed;z-index:999
    }
    .maskContent{
        position: absolute;left: 0;height:310px;overflow:hidden;z-index:2000;  top: 0;bottom:0; right:0;margin:auto;border-radius: 8px;width: 360px;background-color: #fff;text-align: center;
    }
    .confirms{
        position: absolute;left: 0;overflow:hidden;z-index:2000;  top: 0;bottom:0; right:0;margin:auto;text-align: center;
        width:234px;
        height:92px;
        text-align: center;
        line-height: 92px;
        background:rgba(255,255,255,1);
        box-shadow:0px 1px 10px 0px rgba(0,0,0,0.15);
        border-radius:6px;
    }
    .confirms img{
        margin-right: 20px;
    }
    .result{
        position:absolute;top:0%;left:0%;background:transparent;width:100%;height:100%;position:fixed;z-index:999
    }
    .maskHeeard{
        text-align:center;
        background-color:#F6F6F6;
        font-size:18px;
        font-family:PingFangSC-Semibold;
        font-weight:600;
        color:rgba(84,87,102,1);
        line-height:60px;
    }
    .maskForm{
        position:relative;
        padding:0 40px;
    }
    .maskForm input{
        border:none;
        border-bottom:1px solid #EBEBEB;
        outline:none;
        width:280px;
        height: 60px;
        line-height: 60px;
    }
    .sendCode{
        position:absolute;
        right:40px;
        bottom:20px;
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(32,142,255,1);
        line-height:20px;
    }
    .sendCode:hover{
        cursor:pointer;
    }
    .confirm{
        width:280px;
        height:36px;
        background:rgba(32,142,255,1);
        box-shadow:0px 1px 5px 0px rgba(0,0,0,0.05);
        border-radius:4px;
        font-size:14px;
        margin:40px auto 0;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:36px;
        text-align:center;
    }
    .nano-lable{
        width: 175px;
    }
</style>
